function RefundApprovalPage() {
  return <></>;
}

export default RefundApprovalPage;
